module.exports = __webpack_public_path__ + "img/home-part2-bg.7fd88701.png";